import React from "react";
import { format, startOfWeek, addDays } from "date-fns";
import es from "date-fns/locale/es";
import "./CalendarWeekView.css";

const AdminCalendarWeekView = ({ currentDate, timeSlots, detallesSemana, loading, onOpenDetalle }) => {
  const daysOfWeek = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes"];
  const weekStart = startOfWeek(currentDate, { locale: es, weekStartsOn: 1 });

  return (
    <div className="table-responsive">
      <table className="table table-bordered admin-guardias-table">
        <thead className="table-light sticky-header">
          <tr>
            <th className="sticky-column">Hora</th>
            {daysOfWeek.map((day, index) => (
              <th key={index}>
                <span>{day}</span>
                <br />
                <small>{format(addDays(weekStart, index), "dd/MM")}</small>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {timeSlots.map((franja) => (
            <tr key={franja.id}>
              <td className="sticky-column">
                <small>{franja.horaInicio}</small>
                <small className="text-muted d-block">{franja.descripcion}</small>
              </td>
              {daysOfWeek.map((_, dayIndex) => {
                const cellDate = addDays(weekStart, dayIndex);
                const fechaStr = format(cellDate, "yyyy-MM-dd");
                const key = `${fechaStr}|${franja.id}`;
                const detalle = detallesSemana[key];
                const ausencias = detalle?.ausencias || [];
                const asignadas = ausencias.filter((a) => a.profesorGuardia).length;
                const pendientes = ausencias.length - asignadas;
                const firmadas = ausencias.filter((a) => a.firmada).length;
                return (
                  <td key={dayIndex} className="p-2">
                    {loading && !detalle && <small className="text-muted">Cargando...</small>}
                    {detalle?.error && <small className="text-danger">Error al cargar</small>}
                    {!loading && !detalle && !detalle?.error && (
                      <small className="text-muted">Sin datos</small>
                    )}
                    {detalle && !detalle?.error && (
                      <>
                        <div><strong>Tot:</strong> {ausencias.length}</div>
                        <div><strong>Fir:</strong> {firmadas}</div>
                        <div><strong>Asi:</strong> {asignadas}</div>
                        <div><strong>Pen:</strong> {pendientes}</div>
                        <button
                          type="button"
                          className="btn btn-link p-0 mt-1"
                          onClick={() => onOpenDetalle(cellDate, franja)}
                          title="Ver detalle"
                          aria-label="Ver detalle"
                        >
                          &#9432;
                        </button>
                      </>
                    )}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AdminCalendarWeekView;
